/* Skinhye: prevent impossible option combinations on multi-variant products. */
(function () {
  function init() {
    var variants = window.SkinhyeProductVariants;
    if (!Array.isArray(variants) || !variants.length) return;

    var forms = document.querySelectorAll('[data-product-form]');
    forms.forEach(function (form) {
      var inputs = Array.prototype.slice.call(form.querySelectorAll('[data-single-option-selector]'));
      if (!inputs.length) return;
      var busy = false;

      function indexOf(input) {
        return Number(String(input.dataset.index || '').replace('option', '')) - 1;
      }

      function selectedValues() {
        var values = [];
        inputs.forEach(function (input) {
          var index = indexOf(input);
          if (input.checked) values[index] = input.value;
        });
        return values;
      }

      function matchingVariant(values) {
        return variants.find(function (variant) {
          return variant.options.every(function (value, index) { return values[index] === value; });
        });
      }

      function alignToVariant(changed) {
        var values = selectedValues();
        if (matchingVariant(values)) return;
        var pivot = variants.find(function (variant) {
          return variant.options[indexOf(changed)] === changed.value;
        });
        if (!pivot) return;
        inputs.forEach(function (input) {
          var index = indexOf(input);
          if (input.value === pivot.options[index] && !input.checked) {
            input.click();
          }
        });
      }

      inputs.forEach(function (input) {
        input.addEventListener('change', function () {
          if (busy) return;
          busy = true;
          window.setTimeout(function () {
            alignToVariant(input);
            busy = false;
          }, 0);
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
